import Command from '@ckeditor/ckeditor5-core/src/command';
import validateAudioFile from './validateaudiofile';
import { FileRepository } from 'ckeditor5/src/upload';
import { v4 as uuidv4 } from 'uuid';

export default class UploadAudioCommand extends Command {
    execute() {
        const editor = this.editor;
        const t = editor.t;
        const fileRepository = editor.plugins.get(FileRepository);
        const notification = editor.plugins.get('Notification');

        // Crear un input para la selección del archivo
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.aac, .flac, .mp3, .m4a, .oga, .ogg, .wav';

        input.addEventListener('change', async event => {
            const file = event.target.files[0];

            if (!file) return;

            // Validar el archivo
            if (!validateAudioFile(file)) {
                console.log(t('Audio format not supported'));
                return;
            }

            // Subir el archivo usando FileRepository
            const loader = fileRepository.createLoader(file);

            if (loader) {
                try {
                    const uploadResult = await loader.upload();
                    this._insertAudio(uploadResult);
                } catch (error) {
                    console.log(t('error loading audio'));
                }
            } else {
                console.log(t('The file upload could not be started.'));
            }
        });

        input.click();
    }

    _insertAudio(uploadResult) {
        const editor = this.editor;

        editor.model.change(writer => {
            const { file, id, url } = uploadResult;

            // Generar un identificador único
            const uniqueId = uuidv4();

            // Crear el elemento <audioWrapper>
            const wrapperElement = writer.createElement('audioWrapper', {
                'data-id': uniqueId
            });

            // Crear el elemento <audio>
            const audioElement = writer.createElement('audio', {
                src: url,
                'data-file': file,
                'data-id': id,
                'data-url': url
            });

            // Insertar el <audio> dentro del <audioWrapper>
            writer.append(audioElement, wrapperElement);

            // Insertar el <audioWrapper> en la posición actual
            const insertPosition = editor.model.document.selection.getFirstPosition();
            writer.insert(wrapperElement, insertPosition);

            // Mover el cursor al final del contenedor
            writer.setSelection(wrapperElement, 'on');
        });
    }
}
